/**
 * Fired when a stored session turns out to name no client any more: the
 * record was merged into another, or removed (`session_ended`, CMS G11,
 * G13; here G10). signOut() has already run; App mirrors it and tells the
 * person to sign in again. Its own tiny module so App can listen without
 * loading the API helpers up front.
 */
export const SESSION_ENDED_EVENT = 'mpg:session-ended';
